<template>
  <div class="app-multiselect__tag">
    <span class="app-multiselect__tag-label">{{ item ? item.text : '' }} </span>
    <ChipCloseIcon
      class="app-multiselect__tag-close-icon"
      :action="() => removeItem(item.value)"
    />
  </div>
</template>

<script>
  import ChipCloseIcon from './icons/ChipCloseIcon.vue';

  export default {
    components: {
      ChipCloseIcon
    },
    props: {
      item: {
        type: Object,
        default: () => {}
      },
      multiselectRef: {
        type: Object,
        default: () => {}
      }
    },
    methods: {
      removeItem(id) {
        if (this.multiselectRef._props.disabled) return;

        const index = this.multiselectRef._data.selectedItemsLocal.indexOf(id);
        if (index == -1) return;
        this.multiselectRef._data.selectedItemsLocal.splice(index, 1);
      }
    }
  };
</script>

<style lang="scss">
  .app-multiselect__container {
    .app-multiselect__tag {
      background-color: #974900;
      padding: 2px 5px;
      width: fit-content;
      display: flex;
      align-items: center;
      gap: 5px;
      border-radius: 5px;
      user-select: none;

      .app-multiselect__tag-label {
        color: #fff;
        font-family: Raleway;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        white-space: nowrap;
      }

      .app-multiselect__tag-close-icon {
        height: 12px;
        width: 12px;
        cursor: pointer;

        path {
          fill: #fff;
        }

        &:hover {
          path {
            fill: #ffede2;
          }
        }

        &:active {
          path {
            fill: #ffdbc4;
          }
        }
      }
    }
  }
</style>
